__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "redefrota-cardan-web";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@chakra-ui/react", "2.8.2", () => (Promise.all([__webpack_require__.e(827), __webpack_require__.e(214), __webpack_require__.e(986), __webpack_require__.e(434), __webpack_require__.e(796), __webpack_require__.e(579)]).then(() => (() => (__webpack_require__(7827))))));
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(384), __webpack_require__.e(214), __webpack_require__.e(168)]).then(() => (() => (__webpack_require__(384))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(214), __webpack_require__.e(434), __webpack_require__.e(903)]).then(() => (() => (__webpack_require__(5903))))));
			register("framer-motion", "12.40.0", () => (Promise.all([__webpack_require__.e(51), __webpack_require__.e(214), __webpack_require__.e(960)]).then(() => (() => (__webpack_require__(6051))))));
			register("react-dom", "19.1.1", () => (Promise.all([__webpack_require__.e(214), __webpack_require__.e(950)]).then(() => (() => (__webpack_require__(7950))))));
			register("react-router-dom", "7.0.2", () => (Promise.all([__webpack_require__.e(153), __webpack_require__.e(214), __webpack_require__.e(986), __webpack_require__.e(463), __webpack_require__.e(367)]).then(() => (() => (__webpack_require__(3367))))));
			register("react-router", "7.0.2", () => (Promise.all([__webpack_require__.e(153), __webpack_require__.e(214), __webpack_require__.e(774)]).then(() => (() => (__webpack_require__(4774))))));
			register("react", "19.1.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(5043))))));
			initExternal(3640);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};